module.exports = __webpack_public_path__ + "static/media/Mick Elliott.c56b8504.JPG";